import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Block, DefaultText, FlexRow, openModal, SmallGrayText, SmallText } from '@guryou/html-components';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';

const PlayGuideVideoEmbed = ({ videoId, buttonText, modalTitle }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const handleClick = () => {
    dispatch(openModal('embedModal', { embedUrl: `https://www.youtube.com/embed/${videoId}` }, modalTitle));
  };
  return (
    <FlexRow margin={0} padding={0} marginTop={5} xs={12} alignItems="start" flexWrap="nowrap" whiteSpace="nowrap">
      <FlexRow width="auto">
        <img
          src={`https://img.youtube.com/vi/${videoId}/0.jpg`}
          alt="Video thumbnail"
          style={{ cursor: 'pointer', width: '100px', borderRadius: '8px' }}
          onClick={handleClick}
        />
      </FlexRow>
      <div style={{ padding: '6px', overflow: 'hidden', whiteSpace: 'nowrap' }}>
        <SmallGrayText fontWeight={800}>youtube.com</SmallGrayText>
        <DefaultText fontWeight={800} overflow="hidden" whiteSpace="nowrap">
          {modalTitle}
        </DefaultText>
        <Block
          background="black"
          cursor="pointer"
          color="white"
          padding={0.8}
          margin={0}
          width="fit-content"
          borderRadius="5px"
          display="flex"
          flexDirection="row"
          alignItems="center"
          onClick={handleClick}
        >
          <PlayArrowIcon style={{ fontSize: '1.2rem' }} />
          <SmallText color="white" fontWeight={800} marginLeft={1.1} marginRight={1.1} marginTop={0.5}>
            {buttonText || t('GENERAL.watch', 'Guarda')}
          </SmallText>
        </Block>
      </div>
    </FlexRow>
  );
};

export default PlayGuideVideoEmbed;
